<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div v-show="pagetype === 1">
      <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商品编号')" prop="id">
                  <a-input v-model="queryParam.id" @pressEnter="handleQuery" :maxLength="20" :placeholder="$t('请输入')+$t('商品编号')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商品名称')" prop="goodsName">
                  <a-input v-model="queryParam.goodsName" @pressEnter="handleQuery"  :placeholder="$t('请输入')+$t('商品名称')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                  <a-form-item :label="$t('商品状态')" prop="status">
                    <a-select :placeholder="$t('请选择')+$t('商品状态')" style="width: 100%" v-model="queryParam.status" allowClear>
                      <a-select-option v-for="(item, index) in customDict.GoodsOnOffEnum" :value="item.type" :key="index">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              <a-col :md="6" :sm="24">
                <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
          <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
            <img alt="example" style="width: 100%" :src="previewUrl" />
          </a-modal>
        </div>
        <a-tabs v-model="activeKey" @tabClick="changeTab">
          <a-tab-pane key="" tab="全部"/>
          <a-tab-pane v-for="pane in this.customDict.GoodsOnOffEnum" :key="pane.type" :tab="pane.name">
          </a-tab-pane>
        </a-tabs>
      <!-- 操作 -->
        <div class="table-operations">
          <a-button type="primary" @click="handleAdd()" v-hasPermi="['goods:score:add']">
            <a-icon type="plus" />{{$t('新增')}}
          </a-button>
          <a-button type="primary" :disabled="single" @click="handleUpdate(ids)" v-hasPermi="['goods:score:edit']">
            <a-icon type="edit" />{{$t('修改')}}
          </a-button>
          <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['goods:score:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a-button>
          <a-button type="primary" :disabled="multiple" @click="handleOn" v-hasPermi="['goods:goods:batchOn']">
            <a-icon type="check" />{{$t('批量上架')}}
          </a-button>
          <a-button type="danger" :disabled="multiple" @click="handleOff" v-hasPermi="['goods:goods:batchOff']">
            <a-icon type="stop" />{{$t('批量下架')}}
          </a-button>
          <a-button type="primary" @click="handleExport" v-hasPermi="['goods:goods:export']">
            <a-icon type="download" />{{$t('导出')}}
          </a-button>
          <a-button type="primary" :disabled="multiple" @click="handleSelectExport" v-hasPermi="['goods:goods:export']">
            <a-icon type="download" />{{$t('选中导出')}}
          </a-button>
          <table-setting
            :style="{float: 'right'}"
            :table-size.sync="tableSize"
            v-model="columns"
            :refresh-loading="loading"
            @refresh="getList" />
        </div>
        <!-- 数据展示 -->
        <a-table
          v-table-sticky="{ fixedTop: 64 }"
          :scroll="{ x: 1400 }"
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          @change="handleSortChange"
          :columns="columns"
          :data-source="list"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :pagination="false"
          :bordered="tableBordered"
        >
          <template slot="picture" slot-scope="text, record">
            <div>
              <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
            </div>
          </template>
          <span slot="stock" slot-scope="text, record">
            <a @click="updateSkuStock(record.id,record.goodsType)">{{record.stock}}</a>
          </span>
          <span slot="brandId" slot-scope="text, record">
             {{getBrandNameById(record.brandId)}}
          </span>
<!--          <span slot="orderCount" slot-scope="text, record">
            <a v-if="hasPermission('goods:goods:rank')" @click="openRank(record)">{{record.orderCount}}</a>
            <span v-else>{{record.orderCount}}</span>
          </span>-->
          <div slot="status" slot-scope="text, record">
            <a-select style="width: 80%" v-model="record.status"  @change="onStatusChange(record)" v-if="record.status===1|| record.status===0">
              <a-select-option v-for="(item, index) in customDict.GoodsOnOffEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
          <span slot="scoreType" slot-scope="text, record">
              <custom-dict-tag :options="customDict.GoodsScoreTypeEnum" :value="record.scoreType"/>
          </span>
          <span slot="operation" slot-scope="text, record">
            <a-button size="small" type="link" @click="handleCopy(record, undefined)" >
               <a-icon type="copy" />{{$t('复制')}}
            </a-button>
            <br/>
            <a-button size="small" type="link" @click="handleUpdate(record, undefined)" v-hasPermi="['goods:score:edit']">
               <a-icon type="edit" />{{$t('修改')}}
            </a-button>
            <a-button size="small" type="link" @click="handleDelete(record)" v-hasPermi="['goods:score:remove']">
              <a-icon type="delete" />{{$t('删除')}}
            </a-button>
          </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :pageSizeOptions="pageSizeOptions"
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => getTotal(total)"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </div>
    </a-card>
    <score-create-form ref="scoreCreateForm" @ok="getList"/>
    <update-sku-stock ref="updateSkuStock" @ok="getList"></update-sku-stock>
    <goods-audit-form ref="goodsAuditForm" @ok="getList"/>
  </page-header-wrapper>
</template>

<script>
import {batchOn, batchOff, delGoods, pageScoreGoods, batchCopy} from '@/api/goods/goods'
import CustomDictTag from "@/components/DictCustomTag";
import {merchantBrand} from '@/api/goods/brand'
import UpdateSkuStock from "./modules/UpdateSkuStock";
import ScoreCreateForm from "@/views/goods/goods/modules/ScoreCreateForm.vue";
import {mapGetters} from 'vuex'
import {tableMixin} from '@/store/table-mixin'
import {platformCategoryList, merchantCategoryList} from "@/api/goods/category";
import bus from '@/utils/bus'
import moment from 'moment';
import store from "@/store";
import {listSelectMerchant} from "@/api/merchant/merchantMerchant";
import GoodsAuditForm from "@/views/goods/goods/modules/GoodsAuditForm.vue";



export default {
  name: 'Goods',
  components: {
    GoodsAuditForm,
    CustomDictTag,
    UpdateSkuStock,
    ScoreCreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      merchantList:[],
      categoryList: [{id: "0", categoryName: ''}],
      cateOptions: [],
      pagetype: 1,  // 1商品列表 2新增编辑商品页面
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      brandList: [],
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      activeKey: '',
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        goodsCode: undefined,
        goodsName: undefined,
        goodsTypeList: [22],
        merchantCategoryId: undefined,
        merchantId: undefined,
        brandId: undefined,
        isRecommend: undefined,
        isNew: undefined,
        isRestriction: undefined,
        status: undefined,
        labelList: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('商品编号'),
          dataIndex: 'id',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          width: 160,
        },
        {
          title: this.$t('商品名称'),
          dataIndex: 'goodsName',
          width: 300,
        },
        {
          title: this.$t('商品主图'),
          dataIndex: 'picture',
          width: '80px',
          scopedSlots: {customRender: 'picture'},
        },

        {
          title: this.$t('商品状态'),
          dataIndex: 'status',
          width: '100px',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: {customRender: 'status'},
        },
        {
          title: this.$t('积分类型'),
          dataIndex: 'scoreType',
          width: '80px',
          scopedSlots: {customRender: 'scoreType'},
        },
        {
          title: this.$t('商品价'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'price',
          width: '80px',
        },
        {
          title: this.$t('所需积分'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'scorePrice',
          width: '80px',
        },
        {
          title: this.$t('库存'),
          dataIndex: 'stock',
          scopedSlots: {customRender: 'stock'},
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          width: '80px',
        },

        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: 130,
          scopedSlots: {customRender: 'operation'},
        }
      ]
    };
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict','userInfo'])
  },
  mounted() {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    //切换tab
    changeTab(index) {
      if (index == null) {
        index = undefined;
      }
      this.queryParam.status = index;
      this.getList();
    },
    hasPermission(val) {
      const allPermission = '*:*:*'
      const permissions = store.getters && store.getters.permissions
      const hasPermissions = permissions.some(permission => {
        return allPermission === permission || permissions.includes(permission)
      })
      return hasPermissions
    },

    getMerchantList () {
      listSelectMerchant({}).then(response => {
        this.merchantList = response.data
        /*if (this.userInfo.deptType !== 2) {
          //添加一条记录,放到首位
          this.merchantList.unshift({"id": 0,"merchantName":'平台'})
        }*/
      })
    },
    getBrandList() {
      merchantBrand({}).then(response => {
        this.brandList = response.data
      })
    },
    /** 查询商品列表 */
    getList () {
      this.loading = true
     pageScoreGoods(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /*页面初始化时获取分类类别*/
    getCategoryList() {
      merchantCategoryList({}).then(response => {
        this.categoryList = response.data;
        let children = this.handleTree(response.data, 'id', 'pid')
        console.log('children', children)
        this.cateOptions = children
      })
    },


    jumpProperty(id){
      //查看排行
      this.$router.push({
        path: '/goods/property',
        query: {goodsId: id,}
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        goodsCode: undefined,
        goodsName: undefined,
        goodsTypeList: [22],
        merchantCategoryId: undefined,
        merchantId: undefined,
        brandId: undefined,
        isRecommend: undefined,
        isNew: undefined,
        isRestriction: undefined,
        status: undefined,
        labelList: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },




    onStatusChange(record) {
      //商品快捷上下架
      let data = {"idList": [record.id]};
      if (record.status===1) {
        batchOn(data).then(response => {
          if (response.code==='20001') {
            this.$message.success(this.$t('上架成功'), 3)
          }
          this.getList()
        })
      } else if (record.status===0) {
        batchOff(data).then(() => {
          this.getList()
          this.$message.success(
            this.$t('下架成功'),
            3
          )
        })
      }
    },

    updateSkuStock(goodsId,goodsType){
      this.$refs.updateSkuStock.show(goodsId,goodsType);
    },

    handlePreviewGoods(row) {
      let url = 'http://byg1688.com/goods/'+row.id
      window.open(url, '_blank')
    },
    handleCopy(row) {
      this.$refs.scoreCreateForm.handleUpdate(row.id, true)
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.$refs.scoreCreateForm.handleAdd()
    },
    /** 编辑商品信息 **/
    handleUpdate(row) {
      this.$refs.scoreCreateForm.handleUpdate(row.id)
    },

    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      const data = {"idList": this.ids}
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delGoods(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('删除成功'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 批量上架操作 */
    handleOn (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let data = {"idList": this.ids};
      this.$confirm({
        title: this.$t('确认上架'),
        onOk () {
          return batchOn(data)
            .then(response => {
              that.getList()
              if (response.code==='20001') {
                that.onSelectChange([], []);
                that.$message.success(
                  that.$t('上架成功'),
                  3
                )
              }
            })
        },
        onCancel () {
          //取消清空ids列表
          that.ids = []
        }
      })
    },

    handleBatchAudit () {
      const ids = this.ids
      this.$refs.goodsAuditForm.handleAudit(ids)
    },

    /** 批量下架操作 */
    handleOff(row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let data = {"idList": this.ids};
      this.$confirm({
        title: this.$t('确认下架'),
        onOk () {
          return batchOff(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('下架成功'),
                3
              )
            })
        },
        onCancel () {
          //取消清空ids列表
          that.ids = []
        }
      })
    },

    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/goods/goods/export',
            that.queryParam
          , `商品_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleSelectExport () {
      var that = this
      let queryParam = {"idList": this.ids}
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出选中数据'),
        onOk () {
          that.download('biz/admin/goods/score/export', queryParam, `商品_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple=true
          that.selectedRowKeys=[]
        },
        onCancel () {
          that.ids = []
          that.multiple=true
          that.selectedRowKeys=[]
        }
      })
    }
  }
}
</script>
